import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import Headline4 from "../../../../components/headings/Headline4";
import Headline5 from "../../../../components/headings/Headline5";
import Headline6 from "../../../../components/headings/Headline6";
import Styles from "../../styles.module.scss";
import SideMenu from "../../sideMenu";
import DashboardHeader from "../../dashboardHeader";
import { Icon } from '@iconify/react';
import takeTestIcon from "../../../../assets/images/take-test.svg";
import matchedJobsIcon from "../../../../assets/images/matched-jobs.svg";
import completeDetailsIcon from "../../../../assets/images/complete-details.svg";
import * as CONSTANTS from '../../../../utils/CONSTANTS'
import { makeSideBarActive } from '../../../../utils/EllowUtils';
import { useNavigate } from 'react-router-dom';
import { getAPI } from '../../../../api/apis';
import NoData from '../../../../components/noData';
import Accordian from '../../../../components/accordian';
import { postAPI } from "../../../../api/apis";
import NotificationAlert from '../../../../components/notification';
import mixpanelData, { viewedpageMixpanel } from '../../../../utils/mixpanel';
import TestModal from '../../../../modals/testModal';
import Questionire from '../../../../modals/Questionire';
import { getDetails, getJobsForCandidate, getQuestions, updateSurveyData, getFulltimeJobs } from './services';
import Table from '../../../../components/table';
import { getMyContracts } from "./service"
import { REACT_APP_CANDIDATE_FREELANCER , REACT_APP_PROFILE } from '../../../../utils/common';


function DashBoard() {

  const TOTAL_STEPS = 4

  const menu = makeSideBarActive(CONSTANTS.sideMenuFreelancer, 0) 

  const navigate = useNavigate()

  if (!localStorage.getItem("profile_metadata"))
    navigate('/login')

  const candidateStatus = parseInt(localStorage.getItem("candidate_status") || "0") || 0
  const profileMetadata = JSON.parse(localStorage.getItem("profile_metadata") || "") || {}
  const loginId: string = localStorage.getItem('loginId') || ''
  const [candidateData, setCandidateData] = useState<any>()
  const [availableDrop] = useState <boolean> ()
  const [test_id, setTest_id] = useState<number>()
  const [testName, setTestName] = useState<any>()
  const [alert, setAlert] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [surveyStatus, setSurveyStatus] = useState<any>()
  const [visibleTestModal, setVisibleTestModal] = useState<boolean>(false);
  const [visibleQuestionnireModal, setVisibleQuestionnireModal] = useState<boolean>(false)
  const [jobs, setJobs] = useState<{
    job_id: string;
    job_metadata: {
      skills: { id: number; name: string; }[]; jobRole: string;
      customer: { customerId: number; customerDetails:string };
      positionName: string; jobDescription: string; jobResponsibilities: string; jobRequirements: string;
      title: string;
    };
    test_details:
    [
      {
        duration: string, id: number,
        skill: {
          id: number, name: 'Node.js', icon_url: string
        },
        skill_id: string, test_id: string, test_name: string,
        test_result: {
          is_passed: string, test_invite_url: string, status: string;
        }
      }
    ];
    deprecated_position_id: null; status: boolean; "dummy": boolean, "created_by": null, "updated_by": null, "created_on": null, "updated_on": null,
    deprecated_postion_id: number;
  }[]>([])

  const [activeContracts, setActiveContracts] = useState<[]>([])
  const [closedContracts, setClosedContracts] = useState<[]>([])
  const [activeFulltimeJobs, setActiveFulltimeJobs] = useState<[]>([])
  // const [closedFulltimeJobs, setClosedFulltimeJobs] = useState<[]>([])
  // const [contracts, setContracts] = useState<[]>([])
  const [profileDetails, setProfileDetails] = useState<{
    availability: { date: Date; availabilityId: number };
    firstname: string;
    jobroles: { id: number; name: string }[];
    lastname: string;
    status: number;
    techstack: { experience: number; expertise: number; skill: { skillId: number; skillName: string }; stackId: number }[];
  }[]>([])
  const [qestions, setQuestions] = useState<any>()



  const pendingTest = (item: any) => {
    window.location.href = item.test_result.test_invite_url
  }

  const takeTest = (item: any) => {
    let value = {
      loginId: loginId,
      email: profileMetadata.email,
      redirectionUrl: 'https://myworkplace.ellow.io/assessments',
      testId: test_id,
      candidateName: profileMetadata.firstName +' '+profileMetadata.lastName
    }
    let mixpaneldata = {
      distinct_id : profileMetadata.email,
      email: profileMetadata.email,
      redirectionUrl: 'https://myworkplace.ellow.io/assessments',
      testId: test_id,
      candidateName: profileMetadata.firstName +' '+profileMetadata.lastName
    }
    postAPI( REACT_APP_PROFILE + '/test-invite-ext', value).then((response) => {
      if ( response && response.status === 1 ){
        mixpanelData('MWP-Take Test', mixpaneldata)
        mixpanelData('New MWP - Take test',{
          "distinct_id" : profileMetadata.email,
          "Candidate loginid": loginId, 
          "Email": profileMetadata.email,
          "Test id": test_id,
          "Test name": testName,
          "Candidate name": profileMetadata.firstName +' '+profileMetadata.lastName
        })
        window.location.href = response.testUrl
      }else{
        setAlert(true)
        setMessage('Candidate(s) previously invited.')
        setTimeout(() => {
          setAlert(false)
        }, 4000)  
      }
    })
  }


  const testResultPublished = (item: any) => {
    setAlert(true)
    if (item.test_result.invitation_metadata.is_passed) {
      setMessage('Hey, you made it! Our recruiters will get in touch with you soon to know your preferences so that they can get you matched to the most exciting and relevant job opportunities for you!')
    } else {
      setMessage('Hey, do not worry about failure; failures are the stepping stones for a huge success, so do not worry if you fail in the first attempt, you will have another chance to attempt the test after 3 months')
    }
    setTimeout(() => {
      setAlert(false)
    }, 5000);
  }

  const alertOnclose = () => {
    setAlert(false);
  }

  const step1Redirection = () => {
    navigate('/my-profile')
  }
  const step2Redirection = (item: any) => {
    navigate('/assessments')
  }
  const step3Redirection = () => {
    navigate('/jobs')
  }

  useEffect(() => {

    getContracts()
    getProfileDetails()
    getCandidateDetails()
    getContractJobdetails()
    getFulltimeJobdetails()
    viewedpageMixpanel();

    // modalPopup();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (candidateData && candidateData.profile_metadata) {
      getJobs()
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[candidateData])

  const getCandidateDetails = () => {
    getDetails(loginId).then((response) => {
      if (response && response.status === 1) {
        setCandidateData(response.data[0])
        setSurveyStatus(response.data[0].is_survey_completed)
        localStorage.setItem('availablityId',response.data[0].profile_metadata.availability.availabilityId)
        localStorage.setItem('employee_id',response.data[0].employee_id)
        if(response.data[0].profile_metadata.availability.availabilityId === 2){
          localStorage.setItem('date',response.data[0].profile_metadata.availability.date && response.data[0].profile_metadata.availability.date )
        }
        if(response.data[0].profile_metadata.availability.availabilityId === 3){
          localStorage.setItem('weeks',response.data[0].profile_metadata.availability.weeks)
        }  
      }
    })
  }

  const getJobs = () => {

    let body = {
      "skills": candidateData && candidateData.profile_metadata && candidateData.profile_metadata.techStack && candidateData.profile_metadata.techStack.length > 0 && candidateData.profile_metadata.techStack.map((item: any) => item.skill && item.skill.skillName),
      "experience" : candidateData && candidateData.profile_metadata && parseInt(candidateData.profile_metadata.workExperience)
    }
      getJobsForCandidate(body).then((resp) => {
      if (resp && resp.status === 1) {
        setJobs(resp.data)
       }
     })
  }

  const getContracts = () => {
    getAPI( REACT_APP_CANDIDATE_FREELANCER + `/contracts?candidateId=${loginId}`).then(resp => {
      if (resp && resp.status === 1) {
        // setContracts(resp.data)
      }
    })
  }

  const getProfileDetails = () => {
    getAPI( REACT_APP_CANDIDATE_FREELANCER + `/availability?candidateId=${loginId}`).then(resp => {
      if (resp && resp.status === 1) {
        setProfileDetails(resp.data)
      }
    })
  }

  const getContractJobdetails = () => {
    
    let activeContract = {
      "candidateId": loginId,
      "status": "activeContract"
    }
    let completedContract = {
      "candidateId": loginId,
      "status": "completedContracts"
    }

    getMyContracts(activeContract).then((response) => {
      if(response && response.status === 1){
        setActiveContracts(response.data)
        localStorage.setItem("activeContracts",response.data)
      }
    })
    getMyContracts(completedContract).then((response) => {
      if(response && response.status === 1){
        setClosedContracts(response.data)
      }
    })
  }

  const getFulltimeJobdetails = () => {
    let data = {
      "candidateId": loginId,
    }
    getFulltimeJobs(data).then((resp: any) => {
      if(resp && resp.status === 1){
        setActiveFulltimeJobs(resp.data)
      }
    })
  }


//   const modalPopup = (data:any) => {
//     if(data === 'Yes'){
//       setAvailableDrop(true)
//       setavailabilityModal(!availabilityModal)
//     }
//     else{
//     setavailabilityModal(!availabilityModal)
//     setAvailableDrop(false)
//     if ( availabilityModal ){
//       localStorage.setItem('availability', 'false')
//     }
//   }
//   }

  //  const availabilityFlag = localStorage.getItem('availability') ? localStorage.getItem('availability') : null ;

 const profileComplete = (i:any) => {
   switch(i){
     case 0:
       return 
     case 1:
       return navigate('/my-profile')
     case 2:
       return  navigate('/assessments')
     case 3:
       return navigate('/jobs')
   }
 }

  
  const onQuestionireSubmit = (data: any) => {
    updateSurveyData(data).then((response) => {
      if (response && response.status === 1) {
        setVisibleTestModal(true)
        setVisibleQuestionnireModal(false)
        getCandidateDetails()
      }
    })
  }

  const questionModal = (item: any) => {
    setTest_id(item.test_id)
    setTestName(item.test_name)
    if (surveyStatus) {
      setVisibleTestModal(true) 
    }
    else {
      getQuestions().then((response) => {
        if (response && response.status === 1) {
          setQuestions(response.data)
        }
      })
      setVisibleQuestionnireModal(true)
    }
    
}
const closeTestModal = () => {
  setVisibleTestModal(false)
}

  return (

    <section className={Styles.dashboardWrapper}>
       {alert && <NotificationAlert closable={true} onClose={alertOnclose}>{message}</NotificationAlert> }
      {visibleQuestionnireModal && (<Questionire onClose={() => setVisibleQuestionnireModal(false)} questions={qestions} clickHandler={onQuestionireSubmit} />)}
      {visibleTestModal && <TestModal takeTest={takeTest} onClose={closeTestModal} />}
      {/* { availabilityModal && !availabilityFlag && ( <AvailabilityModal  onClose={modalPopup} /> )} */}
      {/* { } */}
      <SideMenu menu={menu} />

      <div className={Styles.dashboardContent}>

        <DashboardHeader dropdown={availableDrop} />

        <div className="contentBox mb-40">
          <div className="innerPadd24">
            <div className={Styles.profileStep}>
              <figure><Icon icon="lucide:user" /></figure>
              <div className={Styles.stepStatus}>
                <h5>{candidateStatus <4 ? 'Your profile is incomplete' : 'Well done, your profile is complete now!'}</h5>
                <div className={Styles.to}>{candidateStatus < 4 && TOTAL_STEPS - candidateStatus > 0  ? TOTAL_STEPS - candidateStatus + 'steps to conplete' : 'Congratulations on completing all steps!'}</div> 
                <div className={Styles.step}>
                  {new Array(TOTAL_STEPS).fill("").map((_, i) => <span key={i} onClick={() => profileComplete(i)} className={i < candidateStatus ? Styles.active : ""}></span>)}
                </div>
                <p>{candidateStatus < 4 && 'You can complete your profile anytime'}</p>
              </div>
            </div>
            <div className={Styles.headMargin}>
              <Headline4>Hey, welcome { profileDetails && profileDetails.length > 0 && profileDetails[0].firstname+" "+profileDetails[0].lastname}! You are almost there!</Headline4>
            </div>
            <p>Your decision to join us fetches you the opportunity to work with top global companies irrespective of your location or time zone. You are now one among the many privileged candidates who have the ability to showcase your expertise to the most trusted leading Brands in solving many complex problems.</p>
            <p>“Perfect job and amazing pay at the comfort of your home”, sounds like a fantasy right? Well, Not anymore! Ellow is the right place to make all your wishes come true.</p>
            <p>Please complete your full profile and clear the Ellow Technical Assessment and get matched to your dream jobs……</p>
          </div>
        </div>

        <Headline5>You are here..</Headline5>

        <div className={Styles.yourSteps}>
          <div className={Styles.yourStepBox} onClick={step1Redirection}>
            <div className={Styles.sepCount}>Step 1</div>
            <figure>
              <img src={completeDetailsIcon} alt='icon'/>
            </figure>
            <Headline6>Complete your detailed profile</Headline6>
            <p>Update your resume and fill in a few additional details to complete your profile</p>
          </div>
          <div className={Styles.yourStepBox} onClick={step2Redirection}>
            <div className={Styles.sepCount}>Step 2</div>
            <figure>
              <img src={takeTestIcon} alt='icon'/>
            </figure>
            <Headline6>Take Test</Headline6>
            <p>Take algorithm and coding challenge based on your core skills</p>
          </div>
          <div className={Styles.yourStepBox} onClick={step3Redirection}>
            <div className={Styles.sepCount}>Step 3</div>
            <figure>
              <img src={matchedJobsIcon} alt='icon'/>
            </figure>
            <Headline6>Get matched with the jobs you deserve</Headline6>
            <p>Relax and let Ellow’s high-powered tool powered with AI find the perfect match!</p>
          </div>
        </div>

        <div className={Styles.whyEllow}>
          <div className={Styles.ellowContent}>
            <h5>Why Ellow?</h5>
            <p><Icon icon="charm:tick" />Ellow resources are trusted by the leading Brands</p>
            <p><Icon icon="charm:tick" />Find jobs from all across the globe in any timezone of your own choice.. Location is not a barrier for the right candidate.. Grab the opportunity you deserve..</p>
            <p><Icon icon="charm:tick" />Our local HR partners help with all operational processes and coachings at any time</p>
          </div>
        </div>

        <div className={Styles.skillsHead}>
          <Headline5>Jobs For You</Headline5>
          <p>
            Check out the jobs that match your expertise
          </p>
        </div>
        <div className={Styles.jobFilter}>
          {/* <label className={Styles.label}>Filtered by:</label> */}
          <div className={Styles.filters}>
            {/* {  profileDetails.length > 0 && profileDetails[0].techstack.map((item: { skill: { skillName: string | undefined; skillId: number | undefined; };},key)  => {
              return <TagLabel key={key} label={item.skill.skillName} value={item.skill.skillId} checked={true} />

            })} */}
          </div>
        </div>
        {((!jobs) || (jobs && jobs.length === 0)) && <NoData/>}
        {/* jobs.filter((item) => item.test_details.length > 0) */}
        {(jobs && jobs.length > 0) && jobs.filter((item) => item.test_details && item.test_details.length > 0).splice(0, 3).map((job, key) => {
          return <div  className={Styles.jobCard} key={key}>
            <div  className={Styles.jobData} >
              <div className={Styles.jobTitle}>
                <div className={Styles.subtitle}>Job Role</div>
                <Headline6>{job.job_metadata.title}</Headline6>
                <div className={Styles.subtitle}></div>
                <p>{job.job_metadata.jobDescription}</p>
                <div className={Styles.jobDecription}>
                  <Link to='/jobdetails' state={[{ jobRole: job.job_metadata.positionName }, { jobDescription: job.job_metadata.jobDescription }, { jobSkills: job.test_details }, { jobResponsiblities: job.job_metadata.jobResponsibilities }, { jobRequirements: job.job_metadata.jobRequirements }, { jobId: job.job_id }]}>Read More</Link>
                </div>
              </div>
            </div>
            <div className={Styles.skillTest}>
              <div className={Styles.subtitle}>Take These Test</div>
              {job.test_details && job.test_details.map((skill, key) => <div className={Styles.testItem} key={key}>
                <img src={skill.skill.icon_url} className={Styles.lan_logo} alt='icon'/>
                <span>{skill.test_name}</span>
                <button onClick={() => skill.test_result ? skill.test_result.is_passed === null ? pendingTest(skill) : testResultPublished(skill) : questionModal(skill) }>
                {skill.test_result ? skill.test_result.is_passed ? 'Passed' : skill.test_result.is_passed !== null ? 'Failed' : 'Pending' : 'Take Test'}
                </button>
              </div>)}
            </div>
          </div>
        })} 
        {/* <div className={Styles.loadMoreButton}><Button variant="secondary" onClick={showMoreJobs}>Show More Jobs</Button></div> */}
        <Headline5>My Contracts</Headline5>
        <div className={Styles.mycontractBox}>
          <div className={Styles.subtitle}>Active Contracts</div>
          <Table type={'contract'} data={activeContracts}/>       
          <div className={Styles.subtitle}>Completed Contracts</div>
          <Table type={'contract'} data={closedContracts}/>    
          {activeFulltimeJobs && activeFulltimeJobs.length > 0 && <>
          <div className={Styles.subtitle}>Fulltime Jobs</div>
          <Table type={'fulltimeJobs'} data={activeFulltimeJobs}/> 
          </>}      
        </div>
        <div>
        {/* <Headline5>Fulltime Jobs</Headline5> */}
        {/* <div className={Styles.mycontractBox}>
      
          <div className={Styles.subtitle}>Completed Contracts</div>
          <Table type={'fulltimeJobs'} data={closedFulltimeJobs}/>          
        </div> */}
        </div>
        <Headline5>Frequently Asked Questions</Headline5>
        <div className={Styles.faqBlock}>
          <Accordian />
        </div>
        {/* <div className={Styles.loadMoreButton}><Button variant="secondary" onClick={viewMore}>View More</Button></div> */}
        {/* <JobDetails/> */}
      </div>
    </section>
  )
}

export default DashBoard